const zh = {
	certification: {
		verification: '实名信息',
		updateHistory: '变更记录',
		certificateRequired: '证件到期提醒',
		changeIdentites: '变更法人、股东、受益人',
		changePerson: '变更法人、股东、受益人',
		completeIdentityVerification: '完善实名信息',
		verificationTips: '根据相关监管机构要求及保障您的账户安全，PingPong需收集用户的真实身份信息并进行验证。',
		verificationTips2nd: 'PingPong承诺将对您提供的实名信息严格保密。',
		imgUploadTips: '上传图片要求：请上传 ',
		imgUploadTips2nd: '原件照片或原件彩色扫描件，确保证件材料四角完整清晰',
		imgUploadTips3rd: '不接受无关水印，黑白复印扫描件或者屏幕拍照。最大不超过10M，格式限定为JPG、JPEG、PNG、BMP、PDF。',
		imgExample: '查看图片示例',
		auditReport: '审核报告',
		writeCompany: '填写公司信息',
		writeLegal: '填写法人信息',
		writeDirector: '填写股东信息',
		writeDirector2: '填写董事信息',
		writeBeneficiary: '填写受益人信息',
		uploadDesc: '请确保照片信息清晰可见，以提升审批时效。'
	},
	review: {
		messageTip: '您的实名信息审核中，请耐心等待',
		messageReSubmit: '您提交的实名认证因为资料缺失或者信息错误原因，导致审核失败，请重新提交。',
		approved: '您的实名信息已审核通过',
		uneligible: '很遗憾，您目前不符合条件。'
	},
	add: {
		applicantsIdentity: '法人信息 Applicant’s Identity',
		informationofApplicant: '请填写企业法人信息',
		addApplicantIdentity: '添加法人',
		shareholderIdentity: '股东信息 Director’s Identity',
		shareholderIdentity2: '董事信息 Director’s Identity',
		informationofshareholder: '请填写企业所有股东信息',
		informationofshareholder2: '请填写企业所有董事信息',
		addashareholder: '添加股东',
		addashareholder2: '添加董事',
		BeneficiaryIdentity: '受益人信息 Beneficiary’s Identity',
		informationofBeneficiary: '请填写持股>=25%的自然人股东信息',
		informationofBeneficiary2: '请填写持股>=25%的自然人董事信息',
		addabeneficiary: '添加受益人',
		goBack: '返回上一步',
		saveAndNext: '保存并进入下一步',
		submitwebsite: '提交并添加网站',
		submitVerification: '提交实名信息',
		save: '暂存上述信息',
		deleted: '删除成功',
		deleteFailed: '删除失败',
		tryAgain: '请重试',
		pic: '添加图片',
		uploadFile: '上传文件',
		reupload: '重新上传',
		uploadSuccess: '文件上传成功',
		notice: '注意',
		uploadFileNotice: '上传文件大小不能超过 ',
		imgLimited: '图片应为JPG、JPEG、PNG、BMP格式',
		pictureFormatError: '文件格式错误',
		picUploadSuccess: '文件上传成功',
		uploadMethods: '请选择上传方式',
		PleaseUploadInformation: '请上传资料',
		uploadFailed: '图片上传失败，请重新上传',
		uploadLimited: '图片应为JPG、JPEG、PNG、BMP格式',
		uploadagain: '请删除原图片重新上传',
		uploadPic1st: '只能上传',
		uploadPic2nd: '张图片哦',
		uploadFileImgAgain: '请删除原文件重新上传',
		uploadFileImg1st: '只能上传',
		uploadFileImg2nd: '个文件哦',
		reupload2: '图片上传失败',
		choose: '选取'
	},
	company: {
		businessType: '公司类型',
		soleProprietorship: '个人独资',
		companyLimited: '有限责任公司',
		jointVentureCompany: '合营公司',
		listedCompany: '上市公司',
		corporationOrganization: '公司、法人、团体',
		others: '其他',
		businessInformation: '公司信息',
		businessLocation: '公司注册所在国家或者地区',
		select: '请选择',
		companyNameEnglish: '公司英文名称',
		businessAddressEnglish: '详细地址（英文）',
		hkBusinessAddressEnglish: '公司英文地址',
		businessIdentityNumber: '营业执照编号',
		phBusinessIdentityNumber: '营业执照编号',

		taxCardNumber: '公司纳税识别号',
		taxCardImg: '印尼税卡（影像）',
		businessEstablishedDate: '公司注册证件生效日期',
		businessExpirationDate: '公司注册证件失效日期',
		license1: '营业执照影像——扫描件',
		license2: '营业执照影像——复印件',
		license3: '法律和人权部证明',
		companyCharter: '公司章程',
		bankAccountInformation: '银行同名账户证明或基本存款账户信息',
		picture: '图片',
		EXCEL: 'EXCEL文件',
		officePhotos: '办公室/店铺照片',
		tokenofficePhotos: '请提供实际经营场所/门店的照片，包含店铺门牌号、进门前台、带有员工及消费者的场景照片，能体现名字或logo',
		logo: '商标logo',
		logoTip: '最大文件大小10MB，尺寸为720px*200px，尽量提供PNG格式',
		addressProof: '地址证明',
		billOrcontract: '公司办公室租赁合同 或 公司水电费账单（请提供带办公地址的水电费账单）',
		hkBillOrcontract: '公司办公室租赁合同',
		selectTheDate: '选择日期',
		longTermEffective: '长期有效',
		partnership: '合伙人证明',
		structure: '股权结构图',
		hkCompanyName: '公司名称', // HK 新增
		hkBusinessAddress: '公司地址', // HK 新增
		hkRegistrationCertificate: '公司注册证书', // HK 新增
		hkRegistrationCertificateNo: '注册证书编号', // HK 新增
		hkCompanyEstablishedDate: '公司注册时间', // HK 新增
		hkBusinessLicenceCertNo: '商业登记号码(前8位)', // HK 新增
		hkBusinessLicenceCertFile: '商业登记证', // HK 新增
		hkBusinessEstablishedDate: '商业登记证书生效日期',
		hkBusinessExpirationDate: '商业登记证书失效日期',
		hkAnnualReport: '法团成立表或周年申报表', // HK 新增,
		hkAnnualReportTips: '成立一年內可以提供NNC1（法团成立表格），一年以上要提供NAR1（周年申报表）', // HK 新增
		phTaxCardNumber: '公司纳税识别号', // PH新增
		phTaxCardImg: '公司纳税卡证件（影像）', // PH新增
		companyRegisterCertificate: '公司注册证明', // 公司注册证明
		generalInfoTable: '通用信息表', // 公司基本信息表
		specialIndustryLicense: '特殊行业许可证', // 特殊行业许可证
		subMerchantInfoTable: '子商户信息表',// 子商户信息表
		registeredCapitalCertificate: '公司注册资金证明',
	},
	person: {
		title1: '证件信息',
		title2: '基本信息',
		title3: '联系信息',
		title4: '居住地址信息',
		nationality: '国籍',
		indonesiaIdPicture: '印尼国民身份证照片',
		vietnamIdPicture: '越南国民身份证照片',
		malaysiaIdPicture: '马来西亚国民身份证照片',
		phPicture: '菲律宾国民身份证照片',
		thPicture: '泰国国民身份证照片',
		jpPicture: '日本国民身份证照片',
		passport: '护照',
		iDIssueDate: '证件生效日期',
		iDExpirationDate: '证件失效日期',
		birthDate: '出生日期',
		enFirstName: '名（英文）',
		enLastName: '姓（英文）',
		originFirstName: '名（母语）',
		originLastName: '姓（母语）',
		birthCountry: '出生国家',
		phone: '联系电话',
		email: '邮箱',
		postcode: '邮编',
		country: '国家',
		state: '省/州',
		city: '市',
		region: '区',
		address: '详细地址（英文）',
		residentialAddress: '居住地址（母语）',
		idCardNumber: '证件号',
		taxCardNumber: '纳税人识别号',
		idCardPicture: '税卡照片',
		sharesProportion: '股份占比',
		picTip: '如您上传的是本人非护照的个人证件，请先上传正面照片，再上传背面照片。',
		authorisedLetterFileName: '代理人授权文件',
		businessTitle: '代理人头衔',
		addressFile: '地址证明',
		ubo: 'UBO申请表',
		uboDownloadDesc: '请填写《受益人申请表》并签字盖章后扫描上传。',
		uboDownloadTitle: '下载《受益人申请表》'
	},
	rules: {
		required: '该字段为必填项',
		sharesRule: '请输入大于等于 0 的股份占比',
		bankAccountInfo: '请上传银行开户许可证或基本存款账户信息',
		proofFlow: '请上传流水证明',
		registeredCompany: '请选择公司注册所在国家或者地区',
		companyChineseName: '请输入公司中文名称',
		companyEnglishName: '请输入公司英文名称',
		chooseCity: '请选择城市',
		companyChineseAddress: '请输入公司中文地址',
		companyEnglishAddress: '请输入公司英文地址',
		companyEnglishCity: '请输入英文城市',
		companyEnglishAddressValid: '请输入有效信息',
		postCode: '请输入邮编',
		postCodeValid: '只允许输入英文和数字',
		businessIdentityNumber: '请输入营业执照号码',
		bussinessEstablishedDate: '请选择营业执照生效日期',
		companyExpiredDate: '请选择公司注册证书失效日期',
		governmentBussinessCertification: '请上传营业执照照片',
		HKgovernmentBussinessCertification: '请上传商业登记证照片',
		governmentBussinessCertification2: '请上传公司注册证书照片',
		applicationForm: '请上传商户申请表',
		websiteCertificate: '请上传网站域名注册证明',
		billOrlease: '请上传公司办公室租赁合同或公司水电费账单',
		addedUser: '使用已添加人物信息',
		IDType: '证件类型',
		IDCardNumber: '证件号码',
		IDNumber: '证件号码',
		IDIssueDate: '证件生效日期',
		IDExpirationDate: '证件失效日期',
		legal: '法人',
		director: '股东',
		director2: '董事姓名',
		beneficial: '受益人',
		legalIDCardUpdate: '法人身份证件更新',
		directorIDCardUpdate: '股东身份证件更新',
		directorIDCardUpdate2: '董事身份证件更新',
		beneficialIDCardUpdate: '受益人身份证件更新',
		legalInfoUpdate: '法人信息更新',
		directorInfoUpdate: '股东信息更新',
		directorInfoUpdate2: '董事信息更新',
		beneficialInfoUpdate: '受益人信息更新',
		companyUpdate: '公司证件更新',
		legalChange: '变更法人',
		directorChange: '变更股东',
		beneficialChange: '变更受益人',
		fullName: '姓名',
		fullNameEN: '姓名 英文',
		firstNameEN: '名 英文',
		lastNameEN: '姓 英文',

		fullShareholderName: '股东姓名',
		fullShareholderName2: '董事姓名',

		fullShareholderNameEN: '股东姓名 英文',
		firstShareholderNameEN: '股东名 英文',
		lastShareholderNameEN: '股东姓 英文',

		fullShareholderNameEN2: '董事姓名 英文',
		firstShareholderNameEN2: '董事名 英文',
		lastShareholderNameEN2: '董事姓 英文',

		fullBeneficiaryName: '受益人姓名',
		fullBeneficiaryNameEN: '受益人姓名 英文',
		firstBeneficiaryNameEN: '受益人名 英文',
		lastBeneficiaryNameEN: '受益人姓 英文',

		halfName: '姓名',
		sameInId: '与证件中的拼音一致',
		phoneNumber: '联系电话',
		emailAddress: '邮箱',
		email: '邮箱格式不正确',
		DOB: '出生日期',
		nationality: '居住地区',
		addressChinese: '中文居住地址',
		ConsistentWithid: '请与证件上的地址保持一致',
		addressEnglish: '英文居住地址',
		save: '保存',
		submit: '保存',
		cancel: '取消',

		InputIDExpirationDate: '请选择证件失效日期',
		saveSuccess: '保存成功',
		saveFailed: '保存失败',
		reSave: '请重新保存',
		selectIDType: '请选择证件类型',
		uploadIDpic: '请上传证件照片',
		uploadIDbackPic: '请上传身份证反面照片',
		inputIDNumber: '请填写证件号码',
		inputIDExpireDate: '请选择证件生效日期',
		pleaseEnter: '请输入',
		realNameCn: '请输入中文名字',
		realNameEn: '请输入英文名字',
		realNameEnRule: '请输入英文字符，不允许输入空格',
		enNameRule: '请输入英文字符',
		enterPhoneNumber: '请输入联系电话',
		enterEmail: '请输入邮箱',
		selectDOB: '请选择出生日期',
		errorDOB: '年龄不能不能小于18周岁',
		selectNation: '请选择居住国家',
		enterAddressChinese: '请输入中文居住地址',
		enterAddressEnglish: '请输入英文居住地址',
		selectBussinessType: '请选择公司类型',
		chinaId: '大陆身份证',
		hongkongId: '香港身份证',
		passport: '护照',
		permit: '大陆往来通行证',
		others: '其他',
		companyCharter: '公司章程',
		otherstuff: '其他信息上传',
		companyCharterWarn: '请上传公司章程',
		companyType: '请选择公司类型',
		selectState: '请选择州',
		inputCity: '请输入城市名',
		selectContinent: '请选择大洲',
		error1: '生效日期不能大于失效日期',
		error2: '失效日期不能小于生效日期',
		error3: '未进行任何操作不能提交'
	},
	approveInfo: {
		menuList: ['公司信息', '法人信息', '股东信息', '董事信息', '受益人信息', '变更记录'],
		edit: '编辑{name}',
		add: '添加{name}',
		save: '保存并提交审核',
		saveWarning: '未进行任何操作不能提交',
		saveError: '至少存在一个{name}',
		cancel: '取消修改',
		legal: {
			desc: '当前的法人为'
		},
		director: {
			desc: '当前的股东为',
			desc2: '当前的董事为'
		},
		beneficial: {
			desc: '当前受益人为'
		}
	},
	update: {
		time: '提交时间',
		type: '变更类型',
		status: '状态',
		operator: '操作人',
		modify: '修改',
		improved: '待完善内容',
		go: '前往',
		forDetail: '查看证件审核情况',
		edit: '填写'
	},
	status: {
		pending: '审核中',
		modify: '待修改',
		passed: '审核通过'
	},
	success: {
		title: '您的实名信息已提交，请继续添加门店',
		tips: ['实名认证已提交审核，我们将在5至7个工作日内返回审核结果,请耐心等待。', '如有任何疑问请联系您的专属客户经理或致电客服: 400-996-9666.'],
		btn: '开始添加门店'
	},
	changePerson: {
		toHistory: '提交后若需查看审核进度，请至 <a href="/aq/offlineKyc?type=updateHistory" style="color:#1fa0e8;display:inline">【变更记录】</a> 中查看',
		changeTo: '变更对象',
		addLegalTip: '提交且审核通过后，该法人将自动替换原法人',
		addLegal: '添加新的法人',
		existDirector: '现有股东（可删除，不可编辑）',
		addDirectorTip: '新增股东',
		addDirector: '添加股东',
		existBeneficial: '现有受益人（可删除，不可编辑）',
		addBeneficialTip: '新增受益人，请填写持股>=25%的自然人股东信息',
		addBeneficial: '添加受益人'
	},
	example: {
		checkImageExamples: '图片示例',
		uploadTip: '上传图片要求：请确保上传资料图片文字清晰可见，最大不超过10M，格式限定为JPG、JPEG、PNG、BMP、PDF。',
		IDCardExample: '身份证示例',
		businessLicense: '企业执照',
		frontofIDCard: '身份证人像面照片',
		backofIDCard: '身份证徽章面照片',
		businessIdentity: '营业执照',
		hongkongId: '香港身份证',
		additionalInformation: '附加信息',
		provideInfo: '您可以提供贵司相关的额外优质材料，以便我们更了解贵司。如董事地址证明、美国国税局EIN证明或个人SSN等信息。',
		uploadMethod: '上传方式',
		passport: '护照首页',
		travelPermit: '大陆往来通行证照片',
		otherPhoto: '其他照片'
	}
}

export default zh
